type LoadingScreenProps = {
  hint?: string;
};

export function LoadingScreen({hint}: LoadingScreenProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-950 text-slate-100">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-800 border-t-primary" />
      <p className="text-sm font-medium text-slate-400">{hint ?? 'Loading…'}</p>
    </div>
  );
}

